var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBag = function SvgIconBag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 29"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.34 9.666V7a6.667 6.667 0 0 1 13.333 0v2.667h4c.736 0 1.333.597 1.333 1.333v16c0 .737-.597 1.334-1.333 1.334H1.339A1.333 1.333 0 0 1 .006 27V11c0-.737.597-1.334 1.333-1.334zm0 2.667H2.672v13.333h18.666V12.333h-2.666v2.666h-2.667v-2.666h-8v2.666H5.339zm2.666-2.667h8V7a4 4 0 0 0-8 0z"
  })));
};
export default SvgIconBag;